import { Button, Col, Row, Space, Spin, Table, Typography } from "antd";
import { ExpandSearch, InputFields, Notification } from "components/common";
import React, { useEffect, useRef, useState } from "react";
import { revenuesCustomerAllColums, revenuesCustomerFields } from "./config";
import dayjs from "dayjs";
import { ExcelSVG, EyeSVG, EyeWhiteSVG } from "assets";
import { EyeSVGIcon } from "pages/Login/Login.config";
import { EyeOutlined } from "@ant-design/icons";
import {
  exportFile,
  formatDateToString,
  formatToCurrencyType,
} from "helper/common";
import accoutingFinancial from "api/accoutingFinancial";
import { useAppSelector } from "redux/hooks";
import { employeeService } from "api";

const RevenusInCustomer = () => {
  const expandRef = useRef<any>();
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [total, setTotal] = useState();
  const [data, setData] = useState([]);
  const [fields, setFields] = useState(revenuesCustomerFields);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    start: dayjs(),
    end: dayjs(),
  });
  const onChangePagination = (page: number, pageSize: number) => {
    setParams({ ...params, page: page, limit: pageSize });
  };
  const activeTab = useAppSelector((e) => e.common.activeTab);

  const onClickSearchButton = async () => {
    try {
      const searchFields = await expandRef.current?.getValidateField();
      setParams({
        ...params,
        ...searchFields,
        page: 1,
      });
    } catch (error) {
      Notification("warning", "Vui lòng nhập đủ thông tin");
    }
  };
  const formatParams = () => {
    return {
      ...params,
      start: formatDateToString(params.start),
      end: formatDateToString(params.end),
    };
  };
  const getList = async () => {
    setLoading(true);
    try {
      const res = await accoutingFinancial.GetRevenuesCustomer(formatParams());
      const newData = res.map((item) => {
        return { ...item, key: item.id };
      });
      setData(newData);
      setTotal(res.total);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi tải dữ liệu");
    }
  };
  const getLHTT = async () => {
    setLoading(true);
    try {
      const res = await accoutingFinancial.getLHTT();
      const options = res.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      revenuesCustomerFields.find(
        (e) => e.name === "loaiHinhThanhToan"
      ).options = options;
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi tải dữ liệu");
    }
  };
  const searchEmployee = async () => {
    const params = {
      page: 1,
      limit: 2000,
    };
    try {
      const res = await employeeService.searchEmployee(params);
      const options = res.items.map((item) => ({
        value: item.hoTen,
        label: item.hoTen,
      }));
      revenuesCustomerFields.find((e) => e.name === "nguoiThucHien").options =
        options;
        setFields([...fields])
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi tải dữ liệu");
    }
  };
  useEffect(() => {
    getLHTT();
    searchEmployee();
  }, []);

  1;
  useEffect(() => {
    getList();
  }, [params, activeTab]);

  const calculateSelectedRowsTotal = (data, dataIndex) => {
    const total = data.reduce((acc, current) => {
      return acc + parseFloat(current[dataIndex]);
    }, 0);

    return isNaN(total) ? "-" : formatToCurrencyType(total.toFixed(0));
  };

  const handleCaculator = (data, name, i) => {
    return (
      <Table.Summary.Cell key={i} index={i} align="right" colSpan={1}>
        <Typography.Text strong>
          {calculateSelectedRowsTotal(data, name)}
        </Typography.Text>
      </Table.Summary.Cell>
    );
  };
  // Export excel
  const getReportFile = async () => {
    const param = formatParams();

    if (param?.start != null || param.end !== null) {
      // const tenKho = listStore.find((e) => e.id == params?.khoId).name;
      exportFile(
        "/store/tckt/export-doanh-thu-theo-kh",
        param,
        `Báo cáo doanh thu theo khách hàng`
      );
    } else {
      Notification("warning", "Chưa chọn ngày để xuất báo cáo");
    }
  };
  const onKeyDown = (e) => {
    if (e.key == "Enter") {
      onClickSearchButton();
    }
  };
  revenuesCustomerAllColums.find((e) => e.dataIndex === "stt").render = (
    v,
    t,
    i
  ) => (params.page - 1) * params.limit + i + 1;
  return (
    <div className="revenues-item">
      <div className="container" onKeyDown={onKeyDown} tabIndex={0}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <ExpandSearch
            ref={expandRef}
            onClickSearch={onClickSearchButton}
            fields={fields}
            initialValues={params}
            isExportExcel={true}
            isSearchExpend={false}
            isSearch={false}
            isResetField={false}
            isShowDetail={true}
            handleExportExcel={getReportFile}
          ></ExpandSearch>
        </Space>
      </div>
      <div className="container">
        <Table
          loading={loading}
          columns={revenuesCustomerAllColums}
          dataSource={data}
          pagination={{
            position: ["bottomRight"],
            showSizeChanger: true,
            total: total,
            onChange: onChangePagination,
            current: params.pages,
          }}
          bordered
          scroll={{ x: "100%" }}
          summary={(data) => {
            return (
              <Table.Summary.Row>
                {revenuesCustomerAllColums.map((e, i) => {
                  if (e.dataIndex === "stt") {
                    return (
                      <Table.Summary.Cell
                        key={i}
                        index={i}
                        colSpan={7}
                        align="center"
                      >
                        <Typography.Text strong>Tổng cộng</Typography.Text>
                      </Table.Summary.Cell>
                    );
                  } else if (
                    e.dataIndex === "soHoaDon" ||
                    e.dataIndex === "tenKhachHang" ||
                    e.dataIndex === "maKhachHang" ||
                    e.dataIndex === "nguoiThucHien" ||
                    e.dataIndex === "thoiGian" ||
                    e.dataIndex === "loaiHinhThanhToan"
                  ) {
                    return <Table.Summary.Cell index={i} key={i} colSpan={0} />;
                  } else return handleCaculator(data, e.dataIndex, i);
                })}
              </Table.Summary.Row>
            );
          }}
        />
      </div>
    </div>
  );
};

export default RevenusInCustomer;
